import "../modules/scrollTo";

$(document).on("click", "[data-behavior~=scroll-to]", function() {
  var target = $("[data-type~= " + $(this).data("target") + "]");
  $(target).scrollTo();
  return false;
});
